import 'bootstrap/dist/css/bootstrap.css';
import React,{Component} from "react";
import './styles.css';

class Selected extends Component{
    
    componentDidMount() {
        this.animateComponent();
      }
    
      componentWillUnmount() {
        this.removeAnimation();
      }

      componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name) {
          this.removeAnimation(); // Remove the animation class when changing the artist
          setTimeout(() => {
            this.animateComponent(); // Add the animation class after a short delay
          }, 10); // You can adjust the delay time as needed
        }
      }

      animateComponent() {
        this.component.classList.add('animate');
        this.removeAnimation();
   // Add the CSS class for animation
      }
    
      removeAnimation() {
        this.component.classList.remove('animate'); // Remove the CSS class to reset the animation
      }

    render(){
        return (
            <div className="fadein" key={this.props.name} ref={(component) => (this.component = component)}>
  <div className="container" style={{textAlign: "center", marginTop: "30px"}}>
        <img 
                                  className='foto'
                                  src={this.props.img}
                                  alt={this.props.name} 
                              />
            <h2>{this.props.name}</h2>
            </div>
            </div>
          );
    }


}

export default Selected